import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ProductLookupModal from './LookupModal';
import ProductErrorModal from './ErrorModal';
import ProductSelectionModal from './SelectionModal';
import ProductDetailsModal from './DetailsModal';
import { closeProductModal } from 'appSrc/redux/actions/productModalManager';

class ProductModalManager extends PureComponent {
    closeModal = () => {
        this.props.dispatch( closeProductModal() );
    }
    render() {
        const { reduxState } = this.props;
        const { showModal, showListOptions, product, type } = reduxState;
        return (
            <div style={ { position: 'absolute', visibility: 'hidden', width: '0', height: '0', top: '-1px', left: '-1px' } } >
                <ProductLookupModal
                    isOpen={ showModal == 'lookupModal' }
                    closeModal={ this.closeModal }
                    showListOptions={ showListOptions } />
                <ProductDetailsModal
                    isOpen={ showModal == 'detailsModal' }
                    product={ product }
                    type={ type }
                    closeModal={ this.closeModal }
                    showLists={ showListOptions } />
                <ProductSelectionModal
                    isOpen={ showModal == 'selectionModal' }
                    product={ product }
                    closeModal={ this.closeModal } />
                <ProductErrorModal
                    isOpen={ showModal == 'errorModal' }
                    closeModal={ this.closeModal } />
            </div>
        );
    }
}

const mapStateToProps = ( state ) => {
    return {
        self: state.self,
        reduxState: state.productModalManager,
    };
};

export default connect( mapStateToProps )( ProductModalManager );
